const baseUrl = '/openapi'
export default {
  "sendEmailCode": baseUrl + "/user/sendEmailCode",
  "sendSmsCode": baseUrl + "/user/sendSmsCode",
  "login": baseUrl + "/user/login",
  "register": baseUrl + "/user/register",
  "editDept": baseUrl + "/user/editDept",
  "editUser": baseUrl + "/user/editUser",
  "docList": baseUrl + "/doc/list",
  "docId": baseUrl + "/doc/",
  "userAppKey": baseUrl + "/user/appKey/list",
  "getUserById": baseUrl + "/user/getUserById",
  "fetchConfig": baseUrl + "/config/fetchConfig",
  "appKeyConfig": baseUrl + "/appKeyConfig",
  "getByAppKey": baseUrl + "/appKeyConfig/getByAppKey",
  "editAppKeyConfig": baseUrl + "/appKeyConfig",
  "getStstoken": baseUrl + "/common/getStstoken",
  "getDeviceSetting": baseUrl + "/config/getDeviceSetting",
  "addDeviceSetting": baseUrl + "/config/addDeviceSetting",
  // "editAppKeyConfig": baseUrl + "/common/getStstoken",
}



// WEBPACK FOOTER //
// ./src/api/api.js